export const getImageUrl = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/food/${src}`;
};

export const getFoodImageUrlPng = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/v2/png/foods/${src}`;
};

export const getFoodImageUrlJpg = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/v2/jpg/foods/${src}`;
};

export const getBackgroundImageUrl = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/banners/static/${src}`;
};

export const getL2ImageUrl = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/v2/png/l2_icons/dark/${src}`;
};

export const getBoostersAndBlockersImageUrl = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/v2/png/booster_and_blockers/${src}`;
};

export const getL2LightImageUrl = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/v2/png/l2_icons/light/${src}`;
};

export const getFoodImageUrl = (src: string) => {
  if (src.endsWith('.jpg')) {
    return getImageUrl(src);
  } else if (src.endsWith('.png')) {
    return getFoodImageUrlPng(src);
  } else {
    return getImageUrl(src);
  }
};

export const getHealthImageUrl = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/v2/jpg/health/${src}`;
};

export const getFoodAndBlockersUrl = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/v2/png/booster_and_blockers/${src}`;
};

export const getLottieFilesFromCdn = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/lottie/${src}`;
};

export const getBackgroundImageUrlHome = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/v2/png/home/${src}`;
};

